// FileExplorer keeps its tree in sessionStorage, one entry per project + scope
// ('root' for the project's own explorer), so tab switches don't refetch.

export const fileExplorerCacheKey = (projectId, scopeKey) =>
  `fileExplorerCache:v4:${projectId}:${scopeKey}`;

// Drop the project explorer's cached tree. Its root node carries the project's
// name, so after a rename the cache would show the old one for the tab session.
export const clearProjectFileExplorerCache = (projectId) => {
  try {
    sessionStorage.removeItem(fileExplorerCacheKey(projectId, 'root'));
  } catch (error) {
    console.warn('Failed to clear File Explorer cache:', error);
  }
};
